/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CheckoutFooter/theme';

export const CheckoutFooterTheme = theme;
